
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { css } from 'aphrodite';

import styles from './styles.js';

class AdminButton extends Component {
    static propTypes = {
        buttonClassName: PropTypes.string.isRequired,
        buttonText: PropTypes.string.isRequired,
        controlId: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number
        ]).isRequired,
        controlType: PropTypes.string,
        handleClick: PropTypes.func,
        isChecked: PropTypes.bool,
        isImage: PropTypes.bool,
        isLink: PropTypes.bool,
        link: PropTypes.string
    }

    static defaultProps = {
        isChecked: false,
        isImage: false,
        isLink: false
    }

    handleClick = () => {
        const { controlId, handleClick, isLink, link } = this.props;
        if (isLink) {
            window.open(
                link,
                '_blank'
            );
        } else {
            handleClick(controlId);
        }
    }

    render() {
        const { handleClick } = this;
        const {
            buttonClassName,
            buttonText,
            isChecked,
            isLink
        } = this.props;
        return (
            <button
                className={
                    isChecked ?
                    css(styles.button, styles[`${buttonClassName}Checked`]) :
                    css(styles.button)
                }
                onClick={handleClick}
            >
                {
                    !isLink ?
                        isChecked ?
                            <i
                                className={`fa fa-check-square-o ${css(styles.icon)}`}
                                aria-hidden="true"
                            /> :
                            <i
                                className={`fa fa-square-o ${css(styles.icon)}`}
                                aria-hidden="true"
                            /> :
                            null
                }
                {buttonText}
            </button>
        );
    }
}

export default AdminButton;



// WEBPACK FOOTER //
// ./src/pages/Search/Main/CardSlider/CardContainer/Card/AdminControls/AdminButton/AdminButton.jsx